const ACCESS_TOKEN_KEY = 'mel_access_token';
const REFRESH_TOKEN_KEY = 'mel_refresh_token';
const USER_KEY = 'mel_user';

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const safeGetItem = (key) => {
  if (!isBrowser()) return null;

  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    console.warn('Unable to access localStorage:', error);
    return null;
  }
};

const safeSetItem = (key, value) => {
  if (!isBrowser()) return;

  try {
    if (value === undefined || value === null) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, value);
    }
  } catch (error) {
    console.warn('Unable to write to localStorage:', error);
  }
};

export const getAccessToken = () => safeGetItem(ACCESS_TOKEN_KEY);

export const getRefreshToken = () => safeGetItem(REFRESH_TOKEN_KEY);

export const getStoredUser = () => {
  const raw = safeGetItem(USER_KEY);

  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn('Unable to parse stored user:', error);
    return null;
  }
};

export const setAuthSession = ({ accessToken, refreshToken, user }) => {
  safeSetItem(ACCESS_TOKEN_KEY, accessToken || null);
  safeSetItem(REFRESH_TOKEN_KEY, refreshToken || null);

  if (user) {
    safeSetItem(USER_KEY, JSON.stringify(user));
  }
};

export const clearAuthSession = () => {
  safeSetItem(ACCESS_TOKEN_KEY, null);
  safeSetItem(REFRESH_TOKEN_KEY, null);
  safeSetItem(USER_KEY, null);
};


